import React from 'react';
import Layout from './Layout';
import { useAuth } from '../contexts/AuthContext';
import RutaProgramadaPanel from './RutaProgramadaPanel';

/**
 * Página dedicada: misma lógica que el panel del dashboard (RutaProgramadaPanel).
 */
const SupervisionRutaProgramada = () => {
  const { user } = useAuth();

  if (user?.rol !== 'S') {
    return (
      <Layout>
        <div className="max-w-3xl mx-auto px-4 py-8">
          <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
            Solo los supervisores pueden acceder a esta sección.
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <RutaProgramadaPanel variant="page" />
    </Layout>
  );
};

export default SupervisionRutaProgramada;
